import { connect } from "react-redux";
import BackToModificationList from "./BackToModificationRequest";
import { bindActionCreators } from "redux";
import {
    financeHierarchyListing,
    getSendBackToModificationRequest,
    userRequestFilter,
    csvDownload
} from "../../../services/redux/userHelpdesk/action";

const mapStateToProps = (state) => ({
    modificationRequestList : state.UserHelpdesk.modificationRequestList,
    filterDetails : state.UserHelpdesk.filterData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        getSendBackToModificationRequest,
        userRequestFilter,
        csvDownload
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BackToModificationList);